module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 148.bdc5a358.png";